export const mapDbToClientType = {
  rv: "RV",
  tent: "Tent",
  rv_tent: "RV or Tent",
  backcountry: "Backcountry",
  lodging: "Lodging",
  group: "Group",
  other: "Other",
};
